import {
  AnchoredPopup,
  IconButton,
  SettingsIcon,
  useAnchoredPopupAnchor,
} from "@carbon6/c6-frontend-design";
import { DiagnosticScalingSettings } from "./DiagnosticScalingSettings";

export function WorkerSettingsButton() {
  const popup = useAnchoredPopupAnchor();

  return (
    <>
      <IconButton
        text="Worker 설정"
        variant="surface"
        selected={popup.open}
        aria-haspopup="dialog"
        aria-expanded={popup.open}
        onClick={popup.open ? popup.close : popup.openFromElement}
      >
        <SettingsIcon />
      </IconButton>
      <AnchoredPopup
        open={popup.open}
        anchor={popup.anchor}
        onClose={popup.close}
        placement="bottom-end"
        width="24rem"
        aria-label="Worker 설정"
        // 키보드로 페이지 팝오버에 들어가고, 닫은 뒤 설정 버튼으로 돌아올 수 있게 한다.
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus="panel"
        returnFocus
      >
        <AnchoredPopup.Body padding="md" scroll>
          <DiagnosticScalingSettings />
        </AnchoredPopup.Body>
        <AnchoredPopup.Footer align="end">
          <IconButton text="닫기" size="sm" variant="surface" onClick={popup.close} />
        </AnchoredPopup.Footer>
      </AnchoredPopup>
    </>
  );
}
